import { useMutation, useQuery } from "@tanstack/react-query";
import { callNewNotiApi } from "lib/api";
import { ResStatus } from "lib/api/enum";
import queryString from "query-string";
import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

const withAuth = (WrappedComponent: React.ComponentType) => {
  const Component = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const query = queryString.parse(location.search);

    useQuery(
      ["callNewNotiApi"],
      () => {
        return callNewNotiApi();
      },
      {
        enabled: true,
        onSuccess: (data) => {
          console.log("callNewNotiApi : ", data);
          if (data.status === ResStatus.RES_UNAUTHORIZED) {
            if (query.c) {
              const c = query.c?.toString();
              if (c !== "smcare" && c !== "cosmocare") {
                navigate("*", {
                  state: { session: "true" },
                  replace: true,
                });
              }
            } else {
              navigate("*", {
                state: { session: "true" },
                replace: true,
              });
            }
          }
        },
      }
    );

    useEffect(() => {
      // user-api를 call 하거나 storage의 데이터를 체크하거나
      const accessToken = localStorage.getItem("accessToken");
      const channel = localStorage.getItem("channel");
      // console.log('withAuth : ', accessToken);
      if (
        accessToken === null ||
        accessToken.length <= 0 ||
        channel === null ||
        channel.length <= 0
      ) {
        if (query.c) {
          const c = query.c?.toString();
          if (c !== "smcare" && c !== "cosmocare") {
            console.log("withAuth null");
            navigate("*", { replace: true });
          }
        }
      } else if (accessToken === "401") {
        // navigate("*", { state: { session: "true" }, replace: true });
      } else {
        // newNotiMutate();
      }
    }, [location]);

    return <WrappedComponent />;
  };
  return Component;
};

export default withAuth;
